import {HttpClient} from "../../service/httpClient/HttpClient";

export class CategoryService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getCategoryList(fundID) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/cost-and-revenue-categories/trees`,
            ).then(resolve).catch(reject)
        })
    }
    createNewCategory(fundID,name,parent) {
        const data = parseInt(parent) >= 0 ?
            {
                "title": name,
                "parent": {
                    "id": parent
                },
                "root": false
            }
            : {
                "title": name,
                "root": true
            }


        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `funds/${fundID}/cost-and-revenue-categories`,
                data
            ).then(resolve).catch(reject)
        })
    }
    updateCategoryInfo(fundID,title, parent, id) {

        const data = parent >= 0 ?
            {
                "title": title,
                "parent": {
                    "id": parent
                },
                "root": false
            }
            : {
                "title": title,
                "root": true
            }


        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `funds/${fundID}/cost-and-revenue-categories/${id}`,
                data
            ).then(resolve).catch(reject)
        })
    }
}